import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { FwLegacyChoiceDialogComponent } from './choice-dialog.component';
import { FwLegacyConfirmDialogComponent } from './confirm-dialog.component';
import { FwLegacyDialogService } from './dialog.service';
import { FwLegacyPortalDialogComponent } from './portal-dialog.component';
import { PipesModule } from '../shared/pipes.module';
import { FwAlertModule, FwAvatarModule, FwButtonModule, FwDialogsModule, FwIconModule, FwLayoutsModule, FwMenuModule, FwSelectMenuModule, FwTextInputModule, FwWrappedInputModule } from '@flywheel-io/vision';
import { ProfileEditDialogComponent } from './profile-edit-dialog/profile-edit-dialog.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../common/directives.module';
import { SharedModule } from '../shared/shared.module';
import { DeleteDialogComponent } from './delete-dialog/delete-dialog.component';
import { BookmarkManagerDialogComponent } from './bookmark-manager-dialog/bookmark-manager-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MaterialModule } from '../material.module';
import { DialogComponent } from './base-dialog/dialog.component';
import { FeatureIfDirective } from '../shared/directives/feature-if.directive';

/**
 * @deprecated Legacy Vision: Please upgrade to the newer FwDialogsModule
 */
@NgModule({
  declarations: [
    FwLegacyChoiceDialogComponent,
    FwLegacyConfirmDialogComponent,
    FwLegacyPortalDialogComponent,
    BookmarkManagerDialogComponent,
    ProfileEditDialogComponent,
    DeleteDialogComponent,
    DialogComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    DragDropModule,
    FeatureIfDirective,
    FormsModule,
    FwAlertModule,
    FwAvatarModule,
    FwButtonModule,
    FwDialogsModule,
    FwLayoutsModule,
    FwIconModule,
    FwMenuModule,
    FwSelectMenuModule,
    FwTextInputModule,
    FwWrappedInputModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatIconModule,
    MatTableModule,
    MaterialModule,
    SharedModule,
    PipesModule,
    PortalModule,
    ReactiveFormsModule,
  ],
  providers: [
    FwLegacyDialogService,
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        disableClose: true,
        hasBackdrop: true,
      },
    },
  ],
  exports: [
    FwLegacyChoiceDialogComponent,
    FwLegacyConfirmDialogComponent,
    FwLegacyPortalDialogComponent,
  ],
})
export class DialogModule {
}
